(ns superadmin.users.details.ocp
  (:require ["@mui/material/Box$default" :as Box]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Typography$default" :as Typography]
            ["@mui/x-data-grid-premium" :refer [DataGridPremium]]
            [common.ocp.view :refer [defocp ocp]]
            [superadmin.users.details.grant-columns :as grant-columns]
            [uix.core :as uix :refer [$]]))

;; OCP for viewing user details
(defocp user-details-ocp :superadmin/user-details
  {:width "50%"}
  [props]
  (let [{:keys [user]} props
        grants (or (:grants user) [])]
    ($ ocp
       {:title (str "User: " (or (:email user) "Details"))}
       ($ Stack {:spacing 3}
          ;; User basic info
          ($ Stack {:spacing 1}
             ($ Typography {:variant "h6"}
                "User Information")
             ($ Stack {:spacing 0.75}
                ($ Stack {:direction "row" :spacing 1}
                   ($ Typography {:variant "body2" :sx #js {:fontWeight "bold" :minWidth "120px"}}
                      "ID:")
                   ($ Typography {:variant "body2"}
                      (str (:id user))))
                ($ Stack {:direction "row" :spacing 1}
                   ($ Typography {:variant "body2" :sx #js {:fontWeight "bold" :minWidth "120px"}}
                      "Name:")
                   ($ Typography {:variant "body2"}
                      (:name user)))
                ($ Stack {:direction "row" :spacing 1}
                   ($ Typography {:variant "body2" :sx #js {:fontWeight "bold" :minWidth "120px"}}
                      "Email:")
                   ($ Typography {:variant "body2"}
                      (:email user)))
                ($ Stack {:direction "row" :spacing 1}
                   ($ Typography {:variant "body2" :sx #js {:fontWeight "bold" :minWidth "120px"}}
                      "Grants:")
                   ($ Typography {:variant "body2"}
                      (str (count grants))))))

          ;; Grants table
          ($ Stack {:spacing 1}
             ($ Typography {:variant "h6"}
                "Grants")
             (if (empty? grants)
               ($ Typography {:variant "body2" :color "text.secondary"}
                  "No grants")
               ($ Box {:sx #js {:height "400px"}}
                  ($ DataGridPremium
                     {:columns grant-columns/grant-columns
                      :rows (to-array grants)
                      :getRowId #(:grant-id %)
                      :rowHeight 40
                      :columnHeaderHeight 40
                      :autoHeight false
                      :disableVirtualization false
                      :hideFooter true
                      :disableRowSelectionOnClick true
                      :disableColumnMenu true
                      :sx #js {:border "none"
                               "& .MuiDataGrid-cell" #js {:borderBottom "1px solid"
                                                          :borderColor "divider"}}}))))))))
